<div *ngIf="isLoading" class="row justify-content-center">
    <div class="col">
        <div class="d-flex align-items-center justify-content-center" style="min-height: 70px;">
            <div class="loading"></div>
        </div>
    </div>
</div>